import * as E from "fp-ts/Either";
import { flow, pipe } from "fp-ts/function";
import * as J from "fp-ts/Json";
import { Node_Type } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import { stringifyWithReplace } from "../../../fp-utils";
const keyToId = (v) => v?.key !== void 0 ? { id: v.key, ...v } : v;
const bulletToBulleted = (v) => v === "BULLET_LIST" ? Node_Type.BULLETED_LIST : v;
const appEmbedIdToItemId = (v) => v?.id && v?.imageSrc ? { ...v, itemId: v.id } : v;
const replacer = (_, v) => pipe(v, keyToId, bulletToBulleted, appEmbedIdToItemId);
var preprocess_default = flow(
  stringifyWithReplace(replacer),
  E.chain(J.parse),
  E.fold(
    () => ({}),
    (res) => res
  )
);
export {
  preprocess_default as default
};
//# sourceMappingURL=preprocess.js.map
